import { useMemo } from 'react';

import styles from './styles.module.css';
import { createEnclosureColumns, createEnclosureRows } from './utils';
import { StatusIndicatorWithStyles } from '../ControlTab/utils';
import DataTable from '@/components/DataTable';
import EmptyState from '@/components/EmptyState';
import GridContainer from '@/components/GridContainer';
import { getEnclosurePath } from '@/solaris-lens-common-lib/src/utils/turbinesPaths';

const enclosureColumns = createEnclosureColumns(StatusIndicatorWithStyles);

export default function EnclosureTab({ turbineData }: { turbineData: any }) {
  const initialData = useMemo(() => {
    if (turbineData) {
      return getEnclosurePath(turbineData) || {};
    }
    return {};
  }, [turbineData]);

  const enclosureRows = useMemo(
    () => createEnclosureRows(initialData),
    [initialData]
  );

  if (enclosureRows.length === 0) {
    return (
      <EmptyState
        title="No data available"
        subtitle="No data available for this tab."
      />
    );
  }

  return (
    <GridContainer gap="0px" align="left" minItemWidth="600px">
      <DataTable
        rows={enclosureRows}
        columns={enclosureColumns}
        type="detail"
        getRowId={row => row.key}
        noLeftMargin={true}
        alignTextLeft={true}
        className={styles.controlTable}
      />
    </GridContainer>
  );
}
